import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './Publica_anuncio.css';

const PublicaAnuncio = () => {
  const navigate = useNavigate();
  // Estados para los campos del formulario
  const [formData, setFormData] = useState({
    nombrePublic: '',
    edad: '',
    descripcion: '',
    region: '',
    ubicacion: '',
    disponibilidad: '',
    genero: '',
    categoria: '',
    whatsapp: '',
    telegram: '',
    tipoValor: '',
    precioUnaHora: '',
    precioMediaHora: ''
  });

// Estados para audio
  const [audioFile, setAudioFile] = useState(null);
  const [audioError, setAudioError] = useState('');
  const [audioURL, setAudioURL] = useState(null);
  const [audioPlayer, setAudioPlayer] = useState(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [showAudioControls, setShowAudioControls] = useState(false);
  const [currentTime, setCurrentTime] = useState(0);
  const [audioDuration, setAudioDuration] = useState(0);
  
  // Estados para modal de video
  const [showVideoModal, setShowVideoModal] = useState(false);
  const [currentVideoSrc, setCurrentVideoSrc] = useState(null);
  const [currentVideoIndex, setCurrentVideoIndex] = useState(null);
  const videoPlayerRef = React.useRef(null);

  // Cache de URLs de blob por archivo, para no regenerarlas en cada render (evita parpadeo de miniaturas)
  const objectUrlCache = React.useRef(new WeakMap());
  const getObjectUrl = (file) => {
    if (!objectUrlCache.current.has(file)) {
      objectUrlCache.current.set(file, URL.createObjectURL(file));
    }
    return objectUrlCache.current.get(file);
  };
  const [videoVolume, setVideoVolume] = useState(1); // 0 a 1
  const [videoCurrentTime, setVideoCurrentTime] = useState(0);
  const [videoDuration, setVideoDuration] = useState(0);
  
  // Estados para modal de foto
  const [showFotoModal, setShowFotoModal] = useState(false);
  const [currentFotoSrc, setCurrentFotoSrc] = useState(null);
  
// Estados para barra de progreso de carga
  const [uploadingIndex, setUploadingIndex] = useState(null);
  const [segundosVerificandoCuadro, setSegundosVerificandoCuadro] = useState(0);

  useEffect(() => {
    if (uploadingIndex) {
      setSegundosVerificandoCuadro(0);
      const intervaloSegundos = setInterval(() => {
        setSegundosVerificandoCuadro(prev => prev + 1);
      }, 1000);
      return () => clearInterval(intervaloSegundos);
    }
  }, [uploadingIndex]);

  // Bloquear scroll del fondo mientras un modal de foto/video esta abierto
  useEffect(() => {
    if (showVideoModal || showFotoModal) {
      const scrollY = window.scrollY;
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.top = `-${scrollY}px`;
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';

      return () => {
        document.documentElement.style.overflow = '';
        document.body.style.overflow = '';
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.left = '';
        document.body.style.right = '';
        document.body.style.width = '';
        window.scrollTo(0, scrollY);
      };
    }
  }, [showVideoModal, showFotoModal]);

  const [uploadProgress, setUploadProgress] = useState({});
  const [colaSubida, setColaSubida] = useState([]); // [{index, tipo, file}, ...]
  
  // Estados para almacenar hashes de archivos
  const [fotosHashes, setFotosHashes] = useState(Array(11).fill(null));
  const [videosHashes, setVideosHashes] = useState(Array(15).fill(null));
  const [fotosTokens, setFotosTokens] = useState(Array(11).fill(null));
  const [videosTokens, setVideosTokens] = useState(Array(15).fill(null));
  const [isVideoPlaying, setIsVideoPlaying] = useState(false);

// Estado para el contador de letras
  const [letrasCount, setLetrasCount] = useState(0);
  const minLetras = 100;
  const maxLetras = 300;

  // Función para formatear números con puntos
  const formatearNumero = (valor) => {
    // Eliminar todo excepto números
    const numeros = valor.replace(/\D/g, '');
    // Agregar puntos como separadores de miles
    return numeros.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  };

  // Manejador especial para campos de precio
  const handlePrecioChange = (e) => {
    const { name, value } = e.target;
    const valorFormateado = formatearNumero(value);
    setFormData(prev => ({
      ...prev,
      [name]: valorFormateado
    }));
  };

  // Manejador para cambio de tipo de valor
  const handleTipoValorChange = (e) => {
    const valor = e.target.value;
    if (valor === 'a_consultar') {
      // Borrar precios si cambia a "A consultar"
      setFormData(prev => ({
        ...prev,
        tipoValor: valor,
        precioUnaHora: '',
        precioMediaHora: ''
      }));
    } else {
      setFormData(prev => ({
        ...prev,
        tipoValor: valor
      }));
    }
  };

  // Estado para las fotos (11 espacios: 1 de perfil + 10 normales)
  const [fotos, setFotos] = useState(Array(11).fill(null));

  // Estado para los videos (15 espacios)
  const [videos, setVideos] = useState(Array(15).fill(null));

  // Estado para los checkboxes de términos
  const [terminos, setTerminos] = useState({
    termino1: false,
    termino2: false,
    termino3: false
  });

  // Estado para mensaje de error de validación
  const [mensajeError, setMensajeError] = useState('');

  // Estados para modal de ticket
  const [showTicketModal, setShowTicketModal] = useState(false);
  const [ticketGenerado, setTicketGenerado] = useState('');
  const [enviando, setEnviando] = useState(false);
  const [progresoCarga, setProgresoCarga] = useState(0);
  const [showBarraCarga, setShowBarraCarga] = useState(false);
  const [barraSaliendo, setBarraSaliendo] = useState(false);
  const [segundosVerificando, setSegundosVerificando] = useState(0);

  // Estado para modal de alerta personalizado (reemplaza alert() nativo del navegador)
  const [mostrarModalAlerta, setMostrarModalAlerta] = useState(false);
  const [mensajeModalAlerta, setMensajeModalAlerta] = useState('');

  // Reemplazo de alert() nativo: este SI se muestra siempre, el navegador no puede silenciarlo
  const mostrarAlertaPersonalizada = (mensaje) => {
    setMensajeModalAlerta(mensaje);
    setMostrarModalAlerta(true);
  };


  useEffect(() => {
    if (progresoCarga === 90 && showBarraCarga) {
      setSegundosVerificando(0);
      const intervaloSegundos = setInterval(() => {
        setSegundosVerificando(prev => prev + 1);
      }, 1000);
      return () => clearInterval(intervaloSegundos);
    }
  }, [progresoCarga, showBarraCarga]);

// Manejar cambios en inputs de texto y selects
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    
    // Si cambia la región, resetear ubicación
    if (name === 'region') {
      setFormData({
        ...formData,
        [name]: value,
        ubicacion: '' // Resetear ubicación
      });
    } else {
      setFormData({
        ...formData,
        [name]: value
      });
    }
    
    // Limpiar mensaje de error cuando el usuario empiece a llenar campos
    if (mensajeError) {
      setMensajeError('');
    }
  };

// Manejar cambio en descripción con límite de letras
  const handleDescripcionChange = (e) => {
    const texto = e.target.value;
    if (texto.length <= maxLetras) {
      setFormData({
        ...formData,
        descripcion: texto
      });
      setLetrasCount(texto.length);
    }
  };

// ============================================
  // IMPORTANTE: CAMBIAR PARA PRODUCCIÓN
  // ============================================
  // En DESARROLLO (HTTP): Usa hash simple
  // En PRODUCCIÓN (HTTPS): Descomentar código SHA-256 abajo
  
  // MÉTODO ACTUAL: Hash simple para desarrollo (HTTP)
  const calcularHashArchivo = async (file) => {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onload = (e) => {
        const arrayBuffer = e.target.result;
        const bytes = new Uint8Array(arrayBuffer);
        
        // Calcular hash basado en:
        // - Nombre del archivo
        // - Tamaño del archivo
        // - Primeros 1000 bytes
        // - Últimos 1000 bytes
        
        let hashString = file.name + file.size;
        
        // Primeros 1000 bytes
        const firstBytes = bytes.slice(0, Math.min(1000, bytes.length));
        for (let i = 0; i < firstBytes.length; i++) {
          hashString += firstBytes[i].toString(16);
        }
        
        // Últimos 1000 bytes
        if (bytes.length > 1000) {
          const lastBytes = bytes.slice(-1000);
          for (let i = 0; i < lastBytes.length; i++) {
            hashString += lastBytes[i].toString(16);
          }
        }
        
        // Generar hash simple (no es criptográfico pero funciona en HTTP)
        let hash = 0;
        for (let i = 0; i < hashString.length; i++) {
          const char = hashString.charCodeAt(i);
          hash = ((hash << 5) - hash) + char;
          hash = hash & hash; // Convertir a 32bit integer
        }
        
        resolve(hash.toString(16));
      };
      reader.readAsArrayBuffer(file);
    });
  };

  // ============================================
  // ⚠️ DESCOMENTAR ESTA FUNCIÓN PARA PRODUCCIÓN (HTTPS) ⚠️
  // ============================================
  /*
  const calcularHashArchivo = async (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = async (e) => {
        const buffer = e.target.result;
        const hashBuffer = await crypto.subtle.digest('SHA-256', buffer);
        const hashArray = Array.from(new Uint8Array(hashBuffer));
        const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
        resolve(hashHex);
      };
      reader.onerror = reject;
      reader.readAsArrayBuffer(file);
    });
  };
  */

  // Función para simular progreso de carga (para UX)
  const simularProgresoCarga = (index, tipo) => {
    return new Promise((resolve) => {
      let progreso = 0;
      const interval = setInterval(() => {
        progreso += 10;
        setUploadProgress(prev => ({
          ...prev,
          [`${tipo}-${index}`]: progreso
        }));
        
        if (progreso >= 100) {
          clearInterval(interval);
          resolve();
        }
      }, 100); // Incrementa cada 100ms
    });
  };

  // Envia un archivo al backend para validacion de seguridad
  // (magic bytes + ClamAV) sin guardarlo de forma definitiva
  const validarArchivoEnServidor = (file, tipo, onProgress) => {
    const intentarValidacion = (intentosRestantes) => {
      return new Promise((resolve) => {
        const backendUrl = process.env.REACT_APP_PUBLICA_ANUNCIO_URL ||
                           `${process.env.REACT_APP_BACKEND_URL}/publica_anuncio`;
        const formData = new FormData();
        formData.append('archivo', file);
        formData.append('tipo', tipo);
        formData.append('id', 0);
        const xhr = new XMLHttpRequest();
        xhr.open('POST', `${backendUrl}/validar_archivo.php`, true);
        xhr.withCredentials = true;
        xhr.upload.onprogress = (event) => {
          if (event.lengthComputable && onProgress) {
            onProgress(Math.round((event.loaded * 100) / event.total));
          }
        };
        xhr.onload = () => {
          try {
            const data = JSON.parse(xhr.responseText);
            if (!data.success) {
              resolve({ valido: false, message: data.message || 'Error al validar el archivo.' });
              return;
            }
            resolve({ valido: data.valido, message: data.message, token: data.token || null });
          } catch (err) {
            if (intentosRestantes > 0) {
              resolve(intentarValidacion(intentosRestantes - 1));
            } else {
              resolve({ valido: false, message: 'No se pudo validar el archivo. Intenta nuevamente.' });
            }
          }
        };
        xhr.onerror = () => {
          if (intentosRestantes > 0) {
            resolve(intentarValidacion(intentosRestantes - 1));
          } else {
            resolve({ valido: false, message: 'No se pudo validar el archivo. Intenta nuevamente.' });
          }
        };
        xhr.send(formData);
      });
    };
    return intentarValidacion(3);
  };

  // Función para verificar duplicados en fotos por hash
  const checkDuplicadoFotoPorHash = (hash) => {
    return fotosHashes.includes(hash);
  };

  // Función para verificar duplicados en videos por hash
  const checkDuplicadoVideoPorHash = (hash) => {
    return videosHashes.includes(hash);
  };

  // Formatear tiempo en formato mm:ss
  const formatearTiempo = (segundos) => {
    const mins = Math.floor(segundos / 60);
    const secs = Math.floor(segundos % 60);
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };

  // Manejar cambios en checkboxes de términos
  const handleTerminoChange = (termino) => {
    setTerminos({
      ...terminos,
      [termino]: !terminos[termino]
    });
  };
  

  // Función para verificar duplicados en fotos
  const checkDuplicadoFoto = (file) => {
    for (let foto of fotos) {
      if (foto && foto.name === file.name && foto.size === file.size) {
        return true;
      }
    }
    return false;
  };

  // Función para verificar duplicados en videos
  const checkDuplicadoVideo = (file) => {
    for (let video of videos) {
      if (video && video.name === file.name && video.size === file.size) {
        return true;
      }
    }
    return false;
  };

  // Función para calcular hash SHA-256 del archivo
  const calculateFileHash = async (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      
      reader.onload = async (e) => {
        try {
          const arrayBuffer = e.target.result;
          const hashBuffer = await crypto.subtle.digest('SHA-256', arrayBuffer);
          const hashArray = Array.from(new Uint8Array(hashBuffer));
          const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
          resolve(hashHex);
        } catch (error) {
          reject(error);
        }
      };
      
      reader.onerror = () => reject(reader.error);
      reader.readAsArrayBuffer(file);
    });
  };

  // Función para verificar duplicados por hash en fotos
  const checkDuplicadoFotoByHash = (hash) => {
    return fotosHashes.includes(hash);
  };

  // Función para verificar duplicados por hash en videos
  const checkDuplicadoVideoByHash = (hash) => {
    return videosHashes.includes(hash);
  };

// Manejar clic en cuadro de foto para selección individual
  const handleFotoClick = (index) => {
    if (fotos[index]) {
      // Si hay foto cargada, abrir modal para ampliar
      setCurrentFotoSrc(URL.createObjectURL(fotos[index]));
      setShowFotoModal(true);
    }
    // Si no hay foto, no hacer nada - solo los botones "Tomar Foto"/"Galeria" deben abrir el selector
  };

  // Cerrar modal de foto
  const closeFotoModal = () => {
    setShowFotoModal(false);
    setCurrentFotoSrc(null);
  };

  const abrirSelectorArchivo = (elementId) => {
    document.getElementById(elementId).click();
  };

  // Procesa un archivo de la cola: valida en el servidor (con progreso real) y calcula su hash
  const procesarItemCola = async ({ index, tipo, file }) => {
    const key = `${tipo}-${index}`;
    setUploadingIndex(key);
    setUploadProgress(prev => ({ ...prev, [key]: 0 }));
    const [resultadoValidacion, hash] = await Promise.all([
      validarArchivoEnServidor(file, tipo, (pct) => {
        setUploadProgress(prev => ({ ...prev, [key]: pct }));
      }),
      calcularHashArchivo(file)
    ]);
    const limpiarProgreso = () => {
      setUploadingIndex(null);
      setUploadProgress(prev => { const n = { ...prev }; delete n[key]; return n; });
    };
    if (!resultadoValidacion.valido) {
      mostrarAlertaPersonalizada(resultadoValidacion.message);
      limpiarProgreso();
      return;
    }
    const esDuplicado = tipo === 'foto' ? checkDuplicadoFotoPorHash(hash) : checkDuplicadoVideoPorHash(hash);
    if (esDuplicado) {
      mostrarAlertaPersonalizada(tipo === 'foto' ? 'NO SE PERMITEN DUPLICIDAD DE FOTOS' : 'NO SE PERMITEN DUPLICIDAD DE VIDEOS');
      limpiarProgreso();
      return;
    }
    if (tipo === 'foto') {
      setFotos(prev => { const n = [...prev]; n[index] = file; return n; });
      setFotosHashes(prev => { const n = [...prev]; n[index] = hash; return n; });
      setFotosTokens(prev => { const n = [...prev]; n[index] = resultadoValidacion.token; return n; });
    } else {
      setVideos(prev => { const n = [...prev]; n[index] = file; return n; });
      setVideosHashes(prev => { const n = [...prev]; n[index] = hash; return n; });
      setVideosTokens(prev => { const n = [...prev]; n[index] = resultadoValidacion.token; return n; });
    }
    limpiarProgreso();
  };

  // Devuelve la posicion (1, 2, 3...) de un cuadro en la cola de subida, o null si no esta en cola
  const obtenerPosicionEnCola = (tipo, index) => {
    const pos = colaSubida.findIndex(item => item.tipo === tipo && item.index === index);
    return pos === -1 ? null : pos + 1;
  };
  // Procesa la cola de subida de a un archivo a la vez, en segundo plano
  useEffect(() => {
    if (uploadingIndex === null && colaSubida.length > 0) {
      const [siguiente, ...resto] = colaSubida;
      setColaSubida(resto);
      procesarItemCola(siguiente);
    }
  }, [colaSubida, uploadingIndex]);


  const handleFotoIndividual = (index, event) => {
    const file = event.target.files[0];
    event.target.value = '';
    if (!file) return;
    const formatosImagenPermitidos = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/webp', 'image/bmp', 'image/svg+xml'];
    if (!formatosImagenPermitidos.includes(file.type)) {
      mostrarAlertaPersonalizada('Subir Foto, formato no válido');
      return;
    }
    setColaSubida(prev => [...prev, { index, tipo: 'foto', file }]);
  };

// Manejar selección múltiple de fotos
  const handleFotosMultiples = async (event) => {
    const files = Array.from(event.target.files);
    const formatosImagenPermitidos = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/webp', 'image/bmp', 'image/svg+xml'];
    
    // Validar que TODOS los archivos sean imágenes
    for (let file of files) {
      if (!formatosImagenPermitidos.includes(file.type)) {
        mostrarAlertaPersonalizada('Subir Foto, formato no válido');
        event.target.value = '';
        return;
      }
    }

    const newFotos = [...fotos];
    const newHashes = [...fotosHashes];
    let espacioIndex = 0;
    
    for (let i = 0; i < newFotos.length && espacioIndex < files.length; i++) {
      if (newFotos[i] === null) {
        const file = files[espacioIndex];
        
        // Mostrar progreso
        setUploadingIndex(`foto-${i}`);
        const progresoPromise = simularProgresoCarga(i, 'foto');
        
        // Calcular hash
        const hash = await calcularHashArchivo(file);
        await progresoPromise;
        
        // Validar duplicados
        if (checkDuplicadoFotoPorHash(hash)) {
          mostrarAlertaPersonalizada('NO SE PERMITEN DUPLICIDAD DE FOTOS');
          event.target.value = '';
          setUploadingIndex(null);
          setUploadProgress({});
          return;
        }
        
newFotos[i] = file;
        newHashes[i] = hash;
        espacioIndex++;
        
        setUploadingIndex(null);
        setUploadProgress(prev => {
          const newProgress = {...prev};
          delete newProgress[`foto-${i}`];
          return newProgress;
        });
      }
    }
    
    setFotos(newFotos);
    setFotosHashes(newHashes);
    event.target.value = '';
  };

// Eliminar foto
  const handleEliminarFoto = (index) => {
    const newFotos = [...fotos];
    const newHashes = [...fotosHashes];
    const newTokens = [...fotosTokens];
    newFotos[index] = null;
    newHashes[index] = null;
    newTokens[index] = null;
    setFotos(newFotos);
    setFotosHashes(newHashes);
    setFotosTokens(newTokens);
  };

// Manejar clic en cuadro de video para selección individual
  const handleVideoClick = (index) => {
    // Si hay video cargado, abrir modal para reproducir
    if (videos[index]) {
      openVideoModal(index);
    }
    // Si no hay video, no hacer nada - solo los botones "Grabar Video"/"Galeria" deben abrir el selector
  };

// Manejar selección de video individual
  // Obtiene el ancho y alto reales de un video sin necesidad de subirlo al servidor
  const obtenerResolucionVideo = (file) => {
    return new Promise((resolve) => {
      const videoEl = document.createElement('video');
      videoEl.preload = 'metadata';
      videoEl.onloadedmetadata = () => {
        window.URL.revokeObjectURL(videoEl.src);
        resolve({ width: videoEl.videoWidth, height: videoEl.videoHeight, duration: videoEl.duration });
      };
      videoEl.onerror = () => {
        resolve({ width: 0, height: 0, duration: 0 });
      };
      videoEl.src = URL.createObjectURL(file);
    });
  };

  const handleVideoIndividual = async (index, event) => {
    const file = event.target.files[0];
    event.target.value = '';
    if (!file) return;
    const formatosVideoPermitidos = ['video/mp4', 'video/avi', 'video/mov', 'video/quicktime', 'video/mkv', 'video/x-matroska', 'video/webm', 'video/flv', 'video/wmv', 'video/x-ms-wmv', 'video/mpeg', 'video/3gpp', 'video/x-msvideo'];
    if (!formatosVideoPermitidos.includes(file.type)) {
      mostrarAlertaPersonalizada('Subir Video, formato no válido');
      return;
    }
    const resolucionVideo = await obtenerResolucionVideo(file);
    const ladoLargoVideo = Math.max(resolucionVideo.width, resolucionVideo.height);
    if (ladoLargoVideo > 1280) {
      mostrarAlertaPersonalizada('El video esta en una resolucion muy alta (' + resolucionVideo.width + 'x' + resolucionVideo.height + '). Ve a la configuracion de camara de tu celular y baja la calidad a 720p o HD (no uses FHD ni 4K), luego intenta subirlo de nuevo.');
      return;
    }
    if (resolucionVideo.duration > 60) {
      mostrarAlertaPersonalizada('El video dura ' + Math.round(resolucionVideo.duration) + ' segundos. La duracion maxima permitida es de 1 minuto (60 segundos). Recorta el video e intenta subirlo de nuevo.');
      return;
    }
    setColaSubida(prev => [...prev, { index, tipo: 'video', file }]);
  };

// Manejar selección múltiple de videos
  const handleVideosMultiples = async (event) => {
    const files = Array.from(event.target.files);
    const formatosVideoPermitidos = ['video/mp4', 'video/avi', 'video/mov', 'video/quicktime', 'video/mkv', 'video/x-matroska', 'video/webm', 'video/flv', 'video/wmv', 'video/x-ms-wmv', 'video/mpeg', 'video/3gpp', 'video/x-msvideo'];
    
    // Validar que TODOS los archivos sean videos
    for (let file of files) {
      if (!formatosVideoPermitidos.includes(file.type)) {
        mostrarAlertaPersonalizada('Subir Video, formato no válido');
        event.target.value = '';
        return;
      }
    }

    const newVideos = [...videos];
    const newHashes = [...videosHashes];
    const newTokens = [...videosTokens];
    let espacioIndex = 0;
    
    for (let i = 0; i < newVideos.length && espacioIndex < files.length; i++) {
      if (newVideos[i] === null) {
        const file = files[espacioIndex];
        
        // Mostrar progreso
        setUploadingIndex(`video-${i}`);
        const progresoPromise = simularProgresoCarga(i, 'video');
        
        // Calcular hash
        const hash = await calcularHashArchivo(file);
        await progresoPromise;
        
        // Validar duplicados
        if (checkDuplicadoVideoPorHash(hash)) {
          mostrarAlertaPersonalizada('NO SE PERMITEN DUPLICIDAD DE VIDEOS');
          event.target.value = '';
          setUploadingIndex(null);
          setUploadProgress({});
          return;
        }
        
        newVideos[i] = file;
        newHashes[i] = hash;
        newTokens[i] = null;
        espacioIndex++;
        
        setUploadingIndex(null);
        setUploadProgress(prev => {
          const newProgress = {...prev};
          delete newProgress[`video-${i}`];
          return newProgress;
        });
      }
    }
    
    setVideos(newVideos);
    setVideosHashes(newHashes);
    setVideosTokens(newTokens);
    event.target.value = '';
  };

// Eliminar video
  const handleEliminarVideo = (index) => {
    const newVideos = [...videos];
    const newHashes = [...videosHashes];
    const newTokens = [...videosTokens];
    newVideos[index] = null;
    newHashes[index] = null;
    newTokens[index] = null;
    setVideos(newVideos);
    setVideosHashes(newHashes);
    setVideosTokens(newTokens);
  };

  // ============================================
  // FUNCIONES PARA MODAL DE VIDEO
  // ============================================

  // Abrir modal de video
  const openVideoModal = (index) => {
    const videoFile = videos[index];
    if (videoFile) {
      const videoURL = URL.createObjectURL(videoFile);
      setCurrentVideoSrc(videoURL);
      setCurrentVideoIndex(index);
      setShowVideoModal(true);
      setIsVideoPlaying(false);
      setVideoCurrentTime(0);
      setVideoDuration(0);
    }
  };

  // Cerrar modal de video
  const closeVideoModal = () => {
    if (videoPlayerRef.current) {
      videoPlayerRef.current.pause();
      videoPlayerRef.current.currentTime = 0;
    }
    if (currentVideoSrc) {
      URL.revokeObjectURL(currentVideoSrc);
    }
    setShowVideoModal(false);
    setCurrentVideoSrc(null);
    setCurrentVideoIndex(null);
    setIsVideoPlaying(false);
    setVideoCurrentTime(0);
    setVideoDuration(0);
  };

  // Play video
  const playVideo = () => {
    if (videoPlayerRef.current) {
      videoPlayerRef.current.play();
      setIsVideoPlaying(true);
    }
  };

  // Pause video
  const pauseVideo = () => {
    if (videoPlayerRef.current) {
      videoPlayerRef.current.pause();
      setIsVideoPlaying(false);
    }
  };

  // Stop video
  const stopVideo = () => {
    if (videoPlayerRef.current) {
      videoPlayerRef.current.pause();
      videoPlayerRef.current.currentTime = 0;
      setIsVideoPlaying(false);
      setVideoCurrentTime(0);
    }
  };

  // Cambiar volumen
  const handleVolumeChange = (e) => {
    const newVolume = parseFloat(e.target.value);
    setVideoVolume(newVolume);
    if (videoPlayerRef.current) {
      videoPlayerRef.current.volume = newVolume;
    }
  };

  // Cambiar tiempo del video (barra de progreso)
  const handleTimeChange = (e) => {
    const newTime = parseFloat(e.target.value);
    setVideoCurrentTime(newTime);
    if (videoPlayerRef.current) {
      videoPlayerRef.current.currentTime = newTime;
    }
  };

  // Actualizar tiempo mientras se reproduce
  const handleVideoTimeUpdate = () => {
    if (videoPlayerRef.current) {
      setVideoCurrentTime(videoPlayerRef.current.currentTime);
    }
  };

  // Cargar metadata del video (duración)
  const handleVideoLoadedMetadata = () => {
    if (videoPlayerRef.current) {
      setVideoDuration(videoPlayerRef.current.duration);
      videoPlayerRef.current.volume = videoVolume;
    }
  };

  // ============================================
  // FUNCIONES PARA AUDIO
  // ============================================

// Subir archivo de audio
  const handleSubirArchivo = async (event) => {
    if (uploadingIndex) {
      mostrarAlertaPersonalizada('Espera a que termine de verificarse el archivo actual antes de subir otro.');
      event.target.value = '';
      return;
    }
    const file = event.target.files[0];
    if (!file) return;
    
    setAudioError('');
    setShowAudioControls(false);
    setCurrentTime(0);
    setAudioDuration(0);
    
    // Detener reproducción si hay una en curso
    if (audioPlayer) {
      audioPlayer.pause();
      setAudioPlayer(null);
      setIsPlaying(false);
    }
    
    // Lista completa de formatos de audio permitidos (15 formatos)
    const formatosAudioPermitidos = [
      '.mp3', '.m4a', '.amr', '.wav', '.ogg', 
      '.opus', '.aac', '.3gp', '.webm', '.flac', 
      '.wma', '.aiff', '.aif', '.oga', '.mp4'
    ];
    
    // Obtener extensión del archivo
    const fileName = file.name.toLowerCase();
    const fileExtension = fileName.substring(fileName.lastIndexOf('.'));
    
    // Validar extensión
    if (!formatosAudioPermitidos.includes(fileExtension)) {
      setAudioError('Formato de audio no permitido. Solo se aceptan archivos de audio válidos.');
      return;
    }

    // Validar seguridad en el servidor (magic bytes + ClamAV) antes de aceptar el audio
    setUploadingIndex('audio');
    const progresoPromise = simularProgresoCarga(0, 'audio');
    const resultadoValidacion = await validarArchivoEnServidor(file, 'audio');
    await progresoPromise;
    setUploadingIndex(null);
    setUploadProgress(prev => {
      const newProgress = {...prev};
      delete newProgress['audio-0'];
      return newProgress;
    });

    if (!resultadoValidacion.valido) {
      setAudioError(resultadoValidacion.message);
      event.target.value = '';
      return;
    }
    
    // Crear URL del archivo
    const url = URL.createObjectURL(file);
    
    // Intentar validar duración (solo si el navegador puede reproducir el formato)
    const audio = new Audio();
    
    audio.addEventListener('loadedmetadata', () => {
      const duration = Math.floor(audio.duration);
      
      // Si el navegador puede leer la duración, validar
      if (duration && !isNaN(duration) && duration > 0) {
        // Validar duración mínima y máxima
        if (duration < 15) {
          setAudioError('AUDIO NO ACEPTADO, MÍNIMO 15 SEGUNDOS');
          URL.revokeObjectURL(url);
          return;
        }
        
        if (duration > 30) {
          setAudioError('AUDIO NO ACEPTADO, MÁXIMO 30 SEGUNDOS');
          URL.revokeObjectURL(url);
          return;
        }
        
        setAudioDuration(duration);
      }
      
      // Archivo válido - guardado temporal en el front
      setAudioFile(file);
      setAudioURL(url);
      setAudioError('');
    });
    
    audio.addEventListener('error', () => {
      // Si el navegador no puede reproducir el formato (ej: .amr)
      // Aceptar el archivo de todos modos (la validación se hará en el backend)
      setAudioFile(file);
      setAudioURL(url);
      setAudioError('');
      setAudioDuration(30); // Asumir duración máxima para el contador
    });
    
    audio.src = url;
  };

// Eliminar audio
  const handleEliminarAudio = () => {
    // Detener reproducción si está en curso
    if (audioPlayer) {
      audioPlayer.pause();
      setAudioPlayer(null);
      setIsPlaying(false);
    }
    
    if (audioURL) {
      URL.revokeObjectURL(audioURL);
    }
    
    setAudioFile(null);
    setAudioURL(null);
    setAudioError('');
    setShowAudioControls(false);
    setCurrentTime(0);
    setAudioDuration(0);
  };

// Mostrar controles y reproducir audio
  const handleEscucharAudio = () => {
    if (!audioURL) {
      setAudioError('No hay audio para reproducir');
      return;
    }
    
    // Mostrar controles
    setShowAudioControls(true);
    
    // Si ya hay un reproductor, reproducir/pausar
    if (audioPlayer) {
      if (isPlaying) {
        audioPlayer.pause();
        setIsPlaying(false);
      } else {
        audioPlayer.play();
        setIsPlaying(true);
      }
    } else {
      // Crear nuevo reproductor
      const audio = new Audio(audioURL);
      
      // Actualizar duración cuando se cargue
      audio.onloadedmetadata = () => {
        const duration = Math.floor(audio.duration);
        if (duration && !isNaN(duration) && duration > 0) {
          setAudioDuration(duration);
        }
      };
      
      // Actualizar tiempo actual mientras reproduce
      audio.ontimeupdate = () => {
        setCurrentTime(Math.floor(audio.currentTime));
      };
      
      audio.onended = () => {
        setIsPlaying(false);
        setCurrentTime(0);
      };
      
      audio.onerror = (error) => {
        console.error('Error al reproducir audio:', error);
        setAudioError('Este formato de audio no puede reproducirse en el navegador, pero se GUARDO CORRECTAMENTE.');
        setIsPlaying(false);
      };
      
      setAudioPlayer(audio);
      audio.play().catch(err => {
        console.error('Error al reproducir:', err);
        setAudioError('Este formato de audio no puede reproducirse en el navegador, pero se GUARDO CORRECTAMENTE.');
      });
      setIsPlaying(true);
    }
  };

// Detener audio
  const handleDetenerAudio = () => {
    if (audioPlayer) {
      audioPlayer.pause();
      audioPlayer.currentTime = 0;
      setIsPlaying(false);
      setCurrentTime(0);
    }
  };


// Manejar envío del formulario
const handleSubmit = async (e) => {
    e.preventDefault();
    // Bloquear el envio si hay un archivo subiendose o si quedan archivos en cola
    if (uploadingIndex !== null || colaSubida.length > 0) {
      mostrarAlertaPersonalizada('Todavía hay fotos o videos subiéndose o en cola. Espera a que terminen antes de enviar la publicación.');
      return;
    }
    
    // Array para almacenar los errores
    const errores = [];
    
    // Validar campos de ANUNCIO
    if (!formData.nombrePublic.trim()) {
      errores.push('- Nombre de publicación');
    }
    if (!formData.edad.trim()) {
      errores.push('- Edad');
    }
    if (!formData.descripcion.trim()) {
      errores.push('- Descripción');
    } else if (formData.descripcion.length < minLetras) {
      errores.push(`- Descripción debe tener mínimo ${minLetras} letras (actualmente tienes ${formData.descripcion.length})`);
    }
    if (!formData.region.trim()) {
      errores.push('- Región');
    }
    if (!formData.ubicacion.trim()) {
      errores.push('- Ubicación');
    }
    if (!formData.disponibilidad.trim()) {
      errores.push('- Disponibilidad');
    }
    if (!formData.genero.trim()) {
      errores.push('- Género');
    }
    if (!formData.categoria.trim()) {
      errores.push('- Categoría');
    }
    if (!formData.whatsapp.trim()) {
      errores.push('- WhatsApp');
    }
    
    // Validar AUDIO
    if (!audioFile) {
      errores.push('- Archivo de audio');
    }
    
    // Validar TIPO de valor
    if (!formData.tipoValor) {
      errores.push('- Tipo de valor (Definir valor o A consultar)');
    }
    
    // Validar PRECIOS solo si eligió "Definir valor"
    if (formData.tipoValor === 'definir_valor') {
      if (!formData.precioUnaHora.trim()) {
        errores.push('- Precio una hora');
      }
      if (!formData.precioMediaHora.trim()) {
        errores.push('- Precio media hora');
      }
    }
    
    // Validar FOTOS (mínimo 5)
    const fotosSubidas = fotos.filter(foto => foto !== null).length;
    if (fotosSubidas < 5) {
      errores.push(`- Mínimo 5 fotos (actualmente tienes ${fotosSubidas})`);
    }
    
    // Validar VIDEOS (mínimo 5)
    const videosSubidos = videos.filter(video => video !== null).length;
    if (videosSubidos < 3) {
      errores.push(`- Mínimo 3 videos (actualmente tienes ${videosSubidos})`);
    }
    
    // Validar TÉRMINOS Y CONDICIONES
    if (!terminos.termino1) {
      errores.push('- Aceptar término 1 (Normas de Publicación)');
    }
    if (!terminos.termino2) {
      errores.push('- Aceptar término 2 (Mayor de 18 años)');
    }
    if (!terminos.termino3) {
      errores.push('- Aceptar término 3 (Términos y Condiciones)');
    }
    
    // Si hay errores, mostrar alert con el listado
    if (errores.length > 0) {
      const mensajeError = 'Faltan los siguientes campos:\n\n' + errores.join('\n');
      mostrarAlertaPersonalizada(mensajeError);
      return;
    }
    
    // Limpiar mensaje de error si todo está bien
    setMensajeError('');

// ============================================
    // ENVIAR AL BACKEND
    // ============================================
    try {
      setEnviando(true);
      setProgresoCarga(0);
      setShowBarraCarga(true);

      // Barra simulada: avanza de 0 a 90% mientras el backend procesa
      let progresoActual = 0;
      const intervalo = setInterval(() => {
        progresoActual += Math.random() * 8 + 2; // Avanza entre 2% y 10% por paso
        if (progresoActual >= 90) {
          progresoActual = 90;
          clearInterval(intervalo);
        }
        setProgresoCarga(Math.round(progresoActual));
      }, 400);

      // Construir FormData con todos los campos
      const data = new FormData();
      data.append('nombre',        formData.nombrePublic);
      data.append('edad',          formData.edad);
      data.append('descripcion',   formData.descripcion);
      data.append('region',        formData.region);
      data.append('ubicacion',     formData.ubicacion);
      data.append('disponibilidad',formData.disponibilidad);
      data.append('genero',        formData.genero);
      data.append('categoria',     formData.categoria);
      data.append('whatsapp',      formData.whatsapp);
      data.append('telegram',      formData.telegram);
      data.append('tipo_valor',    formData.tipoValor);

      if (formData.tipoValor === 'definir_valor') {
        data.append('precio_una_hora',   formData.precioUnaHora);
        data.append('precio_media_hora', formData.precioMediaHora);
      }

      // Audio
      if (audioFile) {
        data.append('audio_file', audioFile);
      }

      // Fotos: usa el token (ya validado, no se vuelve a subir) cuando
      // existe; si no hay token, se manda el archivo completo como respaldo
      const fotosMeta = [];
      fotos.forEach((foto, idx) => {
        if (foto !== null) {
          if (fotosTokens[idx]) {
            fotosMeta.push({ tipo: 'token', valor: fotosTokens[idx] });
          } else {
            fotosMeta.push({ tipo: 'raw' });
            data.append('fotos[]', foto);
          }
        }
      });
      data.append('fotos_meta', JSON.stringify(fotosMeta));

      // Videos: misma logica que fotos
      const videosMeta = [];
      videos.forEach((video, idx) => {
        if (video !== null) {
          if (videosTokens[idx]) {
            videosMeta.push({ tipo: 'token', valor: videosTokens[idx] });
          } else {
            videosMeta.push({ tipo: 'raw' });
            data.append('videos[]', video);
          }
        }
      });
      data.append('videos_meta', JSON.stringify(videosMeta));

      const backendUrl = process.env.REACT_APP_PUBLICA_ANUNCIO_URL || 
                         `${process.env.REACT_APP_BACKEND_URL}/publica_anuncio`;

      const response = await fetch(
        `${backendUrl}/put_publicacion_anuncio.php`,
        {
          method: 'POST',
          credentials: 'include',
          body: data
        }
      );

      // Detener el avance simulado de la barra apenas llega la respuesta real
      // (evita que la barra retroceda si el intervalo seguia corriendo)
      clearInterval(intervalo);

      const result = await response.json();

      if (!result.success) {
        throw new Error(result.message || 'Error al enviar la publicación');
      }

      // Avisar si algun archivo especifico fue rechazado por seguridad
      const rechazos = [];
      if (result.data?.fotos_rechazadas_mensaje) rechazos.push(result.data.fotos_rechazadas_mensaje);
      if (result.data?.videos_rechazados_mensaje) rechazos.push(result.data.videos_rechazados_mensaje);
      if (result.data?.audio_rechazado_mensaje) rechazos.push(result.data.audio_rechazado_mensaje);
      if (rechazos.length > 0) {
        mostrarAlertaPersonalizada(rechazos.join('\n\n'));
      }

      // Completar barra al 100%
      setProgresoCarga(100);

      // Pequeña pausa para que el usuario vea el 100% antes del modal
      await new Promise(resolve => setTimeout(resolve, 600));
      // Desvanecer la barra suavemente antes de ocultarla (evita que desaparezca de golpe)
      setBarraSaliendo(true);
      await new Promise(resolve => setTimeout(resolve, 400));
      setShowBarraCarga(false);
      setBarraSaliendo(false);

      // ============================================
      // MOSTRAR MODAL CON EL TICKET 5 SEGUNDOS
      // ============================================
      const ticket = result.data?.ticket || 'N/D';
      setTicketGenerado(ticket);
      setEnviando(false);
      setShowTicketModal(true);

      // Redirigir a estado_publicaciones después de 5 segundos
      setTimeout(() => {
        setShowTicketModal(false);
        navigate('/estado_publicaciones');
      }, 5000);

    } catch (error) {
      setEnviando(false);
      setShowBarraCarga(false);
      setProgresoCarga(0);
      console.error('Error al enviar:', error);
      setMensajeError('Error al enviar la publicación: ' + error.message);
    }
  };

  return (
    <div className="publica-anuncio-container">
      {/* Header */}
      <div className="header-publica">
        <div className="logo-section">LOGO</div>
        <div className="volver-section" onClick={() => navigate('/panel_creador')} style={{ cursor: 'pointer' }}>VOLVER</div>
      </div>

      {/* Título principal */}
      <div className="titulo-principal">
        FORMULARIO COMPLETAR TODO - OBLIGATORIO
      </div>

      {/* Texto informativo amarillo */}
      <div className="texto-informativo">
        Luego pasara a un proceso de revisión, en la seccion "ESTADO DE TU PUBLICACION", ahi puedes realizar seguimiento.
      </div>

      <form onSubmit={handleSubmit}>
        {/* Sección ANUNCIO */}
        <div className="seccion-form seccion-anuncio">
          <h3 className="titulo-seccion">☞ ANUNCIO :</h3>
          
          <div className="form-group form-group-horizontal">
            <label className="label-campo">Nombre Public</label>
            <input
              type="text"
              name="nombrePublic"
              className="input-campo"
              value={formData.nombrePublic}
              onChange={handleInputChange}
            />
          </div>

          <div className="form-group form-group-horizontal">
            <label className="label-campo">Edad</label>
            <select
              name="edad"
              className="select-campo"
              value={formData.edad}
              onChange={handleInputChange}
            >
              <option value="">Selecciona</option>
              {Array.from({ length: 82 }, (_, i) => i + 18).map(edad => (
                <option key={edad} value={edad}>{edad}</option>
              ))}
            </select>
          </div>

          <div className="form-group form-group-horizontal">
            <label className="label-campo">Descripción</label>
            <textarea
              name="descripcion"
              className="textarea-campo"
              value={formData.descripcion}
              onChange={handleDescripcionChange}
              rows="3"
            ></textarea>
          </div>
          <div className="contador-caracteres" style={{ color: letrasCount >= minLetras ? '#28a745' : '#ff0000' }}>
            Llevas {letrasCount} letras. Mínimo {minLetras}, máximo {maxLetras}.
          </div>

          <div className="form-group form-group-horizontal">
            <label className="label-campo">Región</label>
            <select
              name="region"
              className="select-campo"
              value={formData.region}
              onChange={handleInputChange}
            >
              <option value="">Selecciona</option>
              <option value="Norte del pais">Norte del pais</option>
              <option value="Sur del pais">Sur del pais</option>
              <option value="R Metropolitana - Santiago">R Metropolitana - Santiago</option>
            </select>
          </div>

          <div className="form-group form-group-horizontal">
            <label className="label-campo">Ubicación</label>
            <select
              name="ubicacion"
              className="select-campo"
              value={formData.ubicacion}
              onChange={handleInputChange}
            >
              <option value="">Selecciona</option>
              {formData.region === 'Norte del pais' && (
                <option value="Norte del pais">Norte del pais</option>
              )}
              {formData.region === 'Sur del pais' && (
                <option value="Sur del pais">Sur del pais</option>
              )}
{formData.region === 'R Metropolitana - Santiago' && (
  <>
    <option value="Alto Jahuel">Alto Jahuel</option>
    <option value="Bajos de San Agustín">Bajos de San Agustín</option>
    <option value="Batuco">Batuco</option>
    <option value="Buin">Buin</option>
    <option value="Calera de Tango">Calera de Tango</option>
    <option value="Cerrillos">Cerrillos</option>
    <option value="Cerro Navia">Cerro Navia</option>
    <option value="Conchalí">Conchalí</option>
    <option value="Curacaví">Curacaví</option>
    <option value="El Bosque">El Bosque</option>
    <option value="El Monte">El Monte</option>
    <option value="Estación Central">Estación Central</option>
    <option value="Hospital">Hospital</option>
    <option value="Huechuraba">Huechuraba</option>
    <option value="Independencia">Independencia</option>
    <option value="Isla de Maipo">Isla de Maipo</option>
    <option value="La Cisterna">La Cisterna</option>
    <option value="La Florida">La Florida</option>
    <option value="La Granja">La Granja</option>
    <option value="La Islita">La Islita</option>
    <option value="La Pintana">La Pintana</option>
    <option value="La Reina">La Reina</option>
    <option value="Lampa">Lampa</option>
    <option value="Las Condes">Las Condes</option>
    <option value="Lo Barnechea">Lo Barnechea</option>
    <option value="Lo Espejo">Lo Espejo</option>
    <option value="Lo Prado">Lo Prado</option>
    <option value="Macul">Macul</option>
    <option value="Maipú">Maipú</option>
    <option value="Melipilla">Melipilla</option>
    <option value="Ñuñoa">Ñuñoa</option>
    <option value="Paine">Paine</option>
    <option value="Pedro Aguirre Cerda">Pedro Aguirre Cerda</option>
    <option value="Peñaflor">Peñaflor</option>
    <option value="Peñalolén">Peñalolén</option>
    <option value="Providencia">Providencia</option>
    <option value="Pudahuel">Pudahuel</option>
    <option value="Puente Alto">Puente Alto</option>
    <option value="Quilicura">Quilicura</option>
    <option value="Quinta Normal">Quinta Normal</option>
    <option value="Recoleta">Recoleta</option>
    <option value="Renca">Renca</option>
    <option value="San Bernardo">San Bernardo</option>
    <option value="San Joaquín">San Joaquín</option>
    <option value="San Miguel">San Miguel</option>
    <option value="San Ramón">San Ramón</option>
    <option value="Santiago">Santiago</option>
    <option value="Talagante">Talagante</option>
    <option value="Tiltil">Tiltil</option>
    <option value="Vitacura">Vitacura</option>
    <option value="L1 - Metro San Pablo">L1 - Metro San Pablo</option>
    <option value="L1 - Metro Neptuno">L1 - Metro Neptuno</option>
    <option value="L1 - Metro Pajaritos">L1 - Metro Pajaritos</option>
    <option value="L1 - Metro Las Rejas">L1 - Metro Las Rejas</option>
    <option value="L1 - Metro Ecuador">L1 - Metro Ecuador</option>
    <option value="L1 - Metro San Alberto Hurtado">L1 - Metro San Alberto Hurtado</option>
    <option value="L1 - Metro U de Santiago">L1 - Metro U de Santiago</option>
    <option value="L1 - Metro Estación Central">L1 - Metro Estación Central</option>
    <option value="L1 - Metro Unión Latino Americana">L1 - Metro Unión Latino Americana</option>
    <option value="L1 - Metro Republica">L1 - Metro Republica</option>
    <option value="L1 - Metro Los Heroes">L1 - Metro Los Heroes</option>
    <option value="L1 - Metro La Moneda">L1 - Metro La Moneda</option>
    <option value="L1 - Metro U de Chile">L1 - Metro U de Chile</option>
    <option value="L1 - Metro Santa Lucia">L1 - Metro Santa Lucia</option>
    <option value="L1 - Metro U Catolica">L1 - Metro U Catolica</option>
    <option value="L1 - Metro Baquedano">L1 - Metro Baquedano</option>
    <option value="L1 - Metro Salvador">L1 - Metro Salvador</option>
    <option value="L1 - Metro Manuel Montt">L1 - Metro Manuel Montt</option>
    <option value="L1 - Metro Pedro de Valdivia">L1 - Metro Pedro de Valdivia</option>
    <option value="L1 - Metro Los Leones">L1 - Metro Los Leones</option>
    <option value="L1 - Metro Tobalaba">L1 - Metro Tobalaba</option>
    <option value="L1 - Metro El Golf">L1 - Metro El Golf</option>
    <option value="L1 - Metro Alcantara">L1 - Metro Alcantara</option>
    <option value="L1 - Metro Escuela Militar">L1 - Metro Escuela Militar</option>
    <option value="L1 - Metro Manquehue">L1 - Metro Manquehue</option>
    <option value="L1 - Metro Hernando de Magallanes">L1 - Metro Hernando de Magallanes</option>
    <option value="L1 - Metro Los Dominicos">L1 - Metro Los Dominicos</option>
    <option value="L5 - Metro Plaza de Maipu">L5 - Metro Plaza de Maipu</option>
    <option value="L5 - Metro Santiago Bueras">L5 - Metro Santiago Bueras</option>
    <option value="L5 - Metro Del sol">L5 - Metro Del sol</option>
    <option value="L5 - Metro Monte Tabor">L5 - Metro Monte Tabor</option>
    <option value="L5 - Metro Las Parcelas">L5 - Metro Las Parcelas</option>
    <option value="L5 - Metro Laguna Sur">L5 - Metro Laguna Sur</option>
    <option value="L5 - Metro Barrancas">L5 - Metro Barrancas</option>
    <option value="L5 - Metro Pudahuel">L5 - Metro Pudahuel</option>
    <option value="L5 - Metro San Pablo">L5 - Metro San Pablo</option>
    <option value="L5 - Metro Lo Prado">L5 - Metro Lo Prado</option>
    <option value="L5 - Metro Blanqueado">L5 - Metro Blanqueado</option>
    <option value="L5 - Metro Gruta de Lourdes">L5 - Metro Gruta de Lourdes</option>
    <option value="L5 - Metro Quinta Normal">L5 - Metro Quinta Normal</option>
    <option value="L5 - Metro Cumming">L5 - Metro Cumming</option>
    <option value="L5 - Metro Santa Ana">L5 - Metro Santa Ana</option>
    <option value="L5 - Metro Plaza de Armas">L5 - Metro Plaza de Armas</option>
    <option value="L5 - Metro Bellas Artes">L5 - Metro Bellas Artes</option>
    <option value="L5 - Metro Baquedano">L5 - Metro Baquedano</option>
    <option value="L5 - Metro Parque Bustamante">L5 - Metro Parque Bustamante</option>
    <option value="L5 - Metro Santa Isabel">L5 - Metro Santa Isabel</option>
    <option value="L5 - Metro Irarrazabal">L5 - Metro Irarrazabal</option>
    <option value="L5 - Metro Nuble">L5 - Metro Nuble</option>
    <option value="L5 - Metro Rodrigo de Araya">L5 - Metro Rodrigo de Araya</option>
    <option value="L5 - Metro Carlos Valdovinos">L5 - Metro Carlos Valdovinos</option>
    <option value="L5 - Metro Camino Agricola">L5 - Metro Camino Agricola</option>
    <option value="L5 - Metro San Joaquin">L5 - Metro San Joaquin</option>
    <option value="L5 - Metro Pedrero">L5 - Metro Pedrero</option>
    <option value="L5 - Metro Mirador">L5 - Metro Mirador</option>
    <option value="L5 - Metro Bellavista de la Florida">L5 - Metro Bellavista de la Florida</option>
    <option value="L5 - Metro Vicente Valdes">L5 - Metro Vicente Valdes</option>
    <option value="L2 - Metro Hospital El Pino">L2 - Metro Hospital El Pino</option>
    <option value="L2 - Metro Copa Lo Martinez">L2 - Metro Copa Lo Martinez</option>
    <option value="L2 - Metro Observatorio">L2 - Metro Observatorio</option>
    <option value="L2 - Metro El Bosque">L2 - Metro El Bosque</option>
    <option value="L2 - Metro La Cisterna">L2 - Metro La Cisterna</option>
    <option value="L2 - Metro El Parron">L2 - Metro El Parron</option>
    <option value="L2 - Metro Lo Ovalle">L2 - Metro Lo Ovalle</option>
    <option value="L2 - Metro Ciudad del Nino">L2 - Metro Ciudad del Nino</option>
    <option value="L2 - Metro Departamental">L2 - Metro Departamental</option>
    <option value="L2 - Metro Lo Vial">L2 - Metro Lo Vial</option>
    <option value="L2 - Metro San Miguel">L2 - Metro San Miguel</option>
    <option value="L2 - Metro El Llano">L2 - Metro El Llano</option>
    <option value="L2 - Metro Franklin">L2 - Metro Franklin</option>
    <option value="L2 - Metro Rondizzoni">L2 - Metro Rondizzoni</option>
    <option value="L2 - Metro Parque OHiggins">L2 - Metro Parque OHiggins</option>
    <option value="L2 - Metro Toesca">L2 - Metro Toesca</option>
    <option value="L2 - Metro Los Heroes">L2 - Metro Los Heroes</option>
    <option value="L2 - Metro Santa Ana">L2 - Metro Santa Ana</option>
    <option value="L2 - Metro Puente Cal y Canto">L2 - Metro Puente Cal y Canto</option>
    <option value="L2 - Metro Patronato">L2 - Metro Patronato</option>
    <option value="L2 - Metro Cerro Blanco">L2 - Metro Cerro Blanco</option>
    <option value="L2 - Metro Cementerios">L2 - Metro Cementerios</option>
    <option value="L2 - Metro Einstein">L2 - Metro Einstein</option>
    <option value="L2 - Metro Dorsal">L2 - Metro Dorsal</option>
    <option value="L2 - Metro Zapadores">L2 - Metro Zapadores</option>
    <option value="L2 - Metro Vespucio Norte">L2 - Metro Vespucio Norte</option>
    <option value="L3 - Metro Plaza Quilicura">L3 - Metro Plaza Quilicura</option>
    <option value="L3 - Metro Lo Cruzat">L3 - Metro Lo Cruzat</option>
    <option value="L3 - Metro Ferrocarril">L3 - Metro Ferrocarril</option>
    <option value="L3 - Metro Los Libertadores">L3 - Metro Los Libertadores</option>
    <option value="L3 - Metro Cardenal Caro">L3 - Metro Cardenal Caro</option>
    <option value="L3 - Metro Vivaceta">L3 - Metro Vivaceta</option>
    <option value="L3 - Metro Conchali">L3 - Metro Conchali</option>
    <option value="L3 - Metro Plaza Chacabuco">L3 - Metro Plaza Chacabuco</option>
    <option value="L3 - Metro Hospitales">L3 - Metro Hospitales</option>
    <option value="L3 - Metro Puente Cal y Canto">L3 - Metro Puente Cal y Canto</option>
    <option value="L3 - Metro Plaza de Armas">L3 - Metro Plaza de Armas</option>
    <option value="L3 - Metro Universidad de Chile">L3 - Metro Universidad de Chile</option>
    <option value="L3 - Metro Parque Almagro">L3 - Metro Parque Almagro</option>
    <option value="L3 - Metro Matta">L3 - Metro Matta</option>
    <option value="L3 - Metro Irarrazaval">L3 - Metro Irarrazaval</option>
    <option value="L3 - Metro Monsenor Eyzaguirre">L3 - Metro Monsenor Eyzaguirre</option>
    <option value="L3 - Metro Nunoa">L3 - Metro Nunoa</option>
    <option value="L3 - Metro Chile-Espana">L3 - Metro Chile-Espana</option>
    <option value="L3 - Metro Villa Frei">L3 - Metro Villa Frei</option>
    <option value="L3 - Metro Plaza Egana">L3 - Metro Plaza Egana</option>
    <option value="L3 - Metro Fernando Castillo Velasco">L3 - Metro Fernando Castillo Velasco</option>
    <option value="L4 - Metro Tobalaba">L4 - Metro Tobalaba</option>
    <option value="L4 - Metro Cristobal Colon">L4 - Metro Cristobal Colon</option>
    <option value="L4 - Metro Francisco Bilbao">L4 - Metro Francisco Bilbao</option>
    <option value="L4 - Metro Principe de Gales">L4 - Metro Principe de Gales</option>
    <option value="L4 - Metro Simon Bolivar">L4 - Metro Simon Bolivar</option>
    <option value="L4 - Metro Plaza Egana">L4 - Metro Plaza Egana</option>
    <option value="L4 - Metro Los Orientales">L4 - Metro Los Orientales</option>
    <option value="L4 - Metro Grecia">L4 - Metro Grecia</option>
    <option value="L4 - Metro Los Presidentes">L4 - Metro Los Presidentes</option>
    <option value="L4 - Metro Quilin">L4 - Metro Quilin</option>
    <option value="L4 - Metro Las Torres">L4 - Metro Las Torres</option>
    <option value="L4 - Metro Macul">L4 - Metro Macul</option>
    <option value="L4 - Metro Vicuña Mackenna">L4 - Metro Vicuña Mackenna</option>
    <option value="L4 - Metro Vicente Valdes">L4 - Metro Vicente Valdes</option>
    <option value="L4 - Metro Rojas Magallanes">L4 - Metro Rojas Magallanes</option>
    <option value="L4 - Metro Trinidad">L4 - Metro Trinidad</option>
    <option value="L4 - Metro San Jose de la Estrella">L4 - Metro San Jose de la Estrella</option>
    <option value="L4 - Metro Los Quillayes">L4 - Metro Los Quillayes</option>
    <option value="L4 - Metro Elisa Correa">L4 - Metro Elisa Correa</option>
    <option value="L4 - Metro Hospital Sotero del Rio">L4 - Metro Hospital Sotero del Rio</option>
    <option value="L4 - Metro Protectora de la Infancia">L4 - Metro Protectora de la Infancia</option>
    <option value="L4 - Metro Las Mercedes">L4 - Metro Las Mercedes</option>
    <option value="L4 - Metro Plaza de Puente Alto">L4 - Metro Plaza de Puente Alto</option>
    <option value="L4A - Metro Vicuna Mackenna">L4A - Metro Vicuna Mackenna</option>
    <option value="L4A - Metro Santa Julia">L4A - Metro Santa Julia</option>
    <option value="L4A - Metro La Granja">L4A - Metro La Granja</option>
    <option value="L4A - Metro Santa Rosa">L4A - Metro Santa Rosa</option>
    <option value="L4A - Metro San Ramon">L4A - Metro San Ramon</option>
    <option value="L4A - Metro La Cisterna">L4A - Metro La Cisterna</option>
    <option value="L6 - Metro Cerrillos">L6 - Metro Cerrillos</option>
    <option value="L6 - Metro Lo Valledor">L6 - Metro Lo Valledor</option>
    <option value="L6 - Metro Pedro Aguirre Cerda">L6 - Metro Pedro Aguirre Cerda</option>
    <option value="L6 - Metro Franklin">L6 - Metro Franklin</option>
    <option value="L6 - Metro Bio Bio">L6 - Metro Bio Bio</option>
    <option value="L6 - Metro Nuble">L6 - Metro Nuble</option>
    <option value="L6 - Metro Estadio Nacional">L6 - Metro Estadio Nacional</option>
    <option value="L6 - Metro Nunoa">L6 - Metro Nunoa</option>
    <option value="L6 - Metro Ines de Suarez">L6 - Metro Ines de Suarez</option>
    <option value="L6 - Metro Los Leones">L6 - Metro Los Leones</option>
  </>
)}
            </select>
          </div>

          <div className="form-group form-group-horizontal">
            <label className="label-campo">Disponibilidad</label>
            <select
              name="disponibilidad"
              className="select-campo"
              value={formData.disponibilidad}
              onChange={handleInputChange}
            >
              <option value="">Selecciona</option>
              <option value="Lunes a Viernes">Lunes a Viernes</option>
              <option value="Fin de semana y Festivos">Fin de semana y Festivos</option>
              <option value="Todos los dias">Todos los dias</option>
            </select>
          </div>

          <div className="form-group form-group-horizontal">
            <label className="label-campo">Genero</label>
            <select
              name="genero"
              className="select-campo"
              value={formData.genero}
              onChange={handleInputChange}
            >
              <option value="">Selecciona</option>
              <option value="mujer">mujer</option>
              <option value="hombre">hombre</option>
              <option value="travesti">travesti</option>
            </select>
          </div>

          <div className="form-group form-group-horizontal">
            <label className="label-campo">Categoría</label>
            <select
              name="categoria"
              className="select-campo"
              value={formData.categoria}
              onChange={handleInputChange}
            >
              <option value="">Selecciona</option>
              <option value="Escort">Escort</option>
              <option value="Venta contenido">Venta contenido</option>
              <option value="Masajes">Masajes</option>
            </select>
          </div>
        </div>

{/* Sección Whatsapp y llamada */}
<div className="seccion-form">
  <h3 className="titulo-seccion">☞ Llamada - Whatsapp - Telegram</h3>
  
  <div className="form-group form-group-horizontal">
    <label className="label-campo label-whatsapp">Whatsapp</label>
    <div className="input-con-prefijo">
      <span className="prefijo">+56</span>
      <input
        type="text"
        name="whatsapp"
        className="input-campo input-con-prefijo-field"
        value={formData.whatsapp}
        onChange={handleInputChange}
      />
    </div>
  </div>

  <div className="form-group form-group-horizontal">
    <label className="label-campo label-whatsapp">Telegram</label>
    <div className="input-con-prefijo">
      <span className="prefijo">+56</span>
      <input
        type="text"
        name="telegram"
        className="input-campo input-con-prefijo-field"
        value={formData.telegram}
        onChange={handleInputChange}
      />
    </div>
  </div>
</div>

{/* Sección Audio para presentación */}
        <div className="seccion-form">
          <h3 className="titulo-seccion">☞ Audio para presentación</h3>
          
          {/* Instrucciones detalladas */}
          <div className="descripcion-seccion instrucciones-audio">
            <p>• Duración del audio mínimo son 15 segundos, máximo 30 segundos.</p>
            
            <p>• Tienes dos opciones <span className="texto-rojo-destacado">GRABAR AUDIO</span> y <span className="texto-rojo-destacado">SUBIR ARCHIVO</span>.</p>
            
            <p>• Al pinchar el botón <span className="texto-rojo-destacado">GRABAR AUDIO</span>, te da la facilidad de grabar el audio al instante.</p>
            
            <p>• <span className="texto-rojo-destacado">SUBIR ARCHIVO</span>, solo permite audios grabados desde la app de tu celular <span className="texto-rojo-destacado">"Grabador de voz"</span>, cuando selecciones el botón "subir archivo", puedes ir a buscar ese archivo que tienes alojado en tu celular, puedes reproducirlo y optar por si te gusta o no.</p>
            
            <p>• También puedes eliminarlo.</p>
            
            <p>• Una vez tengas tu audio elegido, solo déjalo en el formulario <span className="texto-rojo-destacado">"DEBE APARECER EN EL RECUADRO BLANCO"</span>, AHÍ YA ESTÁ CARGADO.</p>
            
            <p className="nota-soporte">• Nota: en caso de dudas, contáctanos a soporte para ayudarte.</p>
          </div>

          <div className="audio-buttons-container">
            <label className="btn-audio btn-verde" style={{ cursor: 'pointer', margin: 0 }}>
              Grabar audio
              <input
                type="file"
                accept="audio/*"
                capture="microphone"
                onChange={handleSubirArchivo}
                style={{ display: 'none' }}
              />
            </label>
            <label className="btn-audio btn-azul" style={{ cursor: 'pointer', margin: 0 }}>
              Subir archivo creado
              <input
                type="file"
                accept="audio/*"
                onChange={handleSubirArchivo}
                style={{ display: 'none' }}
              />
            </label>

            <button 
              type="button" 
              className="btn-audio btn-rojo"
              onClick={handleEliminarAudio}
            >
              Eliminar
            </button>
          </div>

          {/* Mensaje de error */}
          {audioError && (
            <div className="audio-error-message">
              {audioError}
            </div>
          )}

          {/* Barra de validacion en tiempo real */}
          {uploadingIndex === 'audio' && (
            <div className="upload-progress-container">
              <div className="upload-progress-bar">
                <div 
                  className="upload-progress-fill"
                  style={{ width: `${uploadProgress['audio-0'] || 0}%` }}
                ></div>
              </div>
              <div className="upload-progress-text">
                {uploadProgress['audio-0'] || 0}%
              </div>
              <div className="upload-progress-label">Validando...</div>
            </div>
          )}

          {/* Preview del archivo de audio */}
          <div className="audio-preview">
            <div className="audio-preview-box">
              {audioFile && (
                <div className="audio-file-display">
                  {audioFile.name}
                </div>
              )}
            </div>
          </div>

          {/* Controles de audio */}
          <div className="audio-controls">
            <button 
              type="button" 
              className="btn-audio btn-azul"
              onClick={handleEscucharAudio}
              disabled={!audioFile}
              style={{ opacity: audioFile ? 1 : 0.5 }}
            >
              Escucha tu audio
            </button>
            
            {showAudioControls && audioFile && (
              <>
                <button 
                  type="button" 
                  className="btn-control-audio"
                  onClick={handleEscucharAudio}
                  title={isPlaying ? "Pausar" : "Reproducir"}
                >
                  {isPlaying ? '⏸' : '▶'}
                </button>
                <button 
                  type="button" 
                  className="btn-control-audio"
                  onClick={handleDetenerAudio}
                  title="Detener"
                >
                  ⏹
                </button>
                <div className="audio-time-counter">
                  {currentTime}-{audioDuration || 30} seg
                </div>
              </>
            )}
          </div>
        </div>


{/* Sección Valores */}
        <div className="seccion-form">
          <h3 className="titulo-seccion">☞ Valores</h3>
          
          <p className="descripcion-seccion">
            Elige una opción en el campo <strong>"TIPO"</strong> para no definir el valor y que consulten o definir un valor.
          </p>

          <div className="tipo-valor-container">
            <label className="tipo-valor-label">TIPO</label>
            <select
              name="tipoValor"
              className="tipo-valor-select"
              value={formData.tipoValor}
              onChange={handleTipoValorChange}
            >
              <option value="">Selecciona</option>
              <option value="definir_valor">Definir valor</option>
              <option value="a_consultar">A consultar</option>
            </select>
          </div>

          <table className="tabla-valores">
            <thead>
              <tr>
                <th>Tiempo</th>
                <th>Valor</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="label-precio">Precio una hora</td>
                <td className="valor-con-signo">
                  <span className="signo-peso">$</span>
                  <input
                    type="text"
                    name="precioUnaHora"
                    className="input-precio"
                    value={formData.precioUnaHora}
                    onChange={handlePrecioChange}
                    placeholder={formData.tipoValor === 'a_consultar' ? 'A consultar' : 'Coloca tu precio'}
                    disabled={formData.tipoValor !== 'definir_valor'}
                    style={{
                      backgroundColor: formData.tipoValor !== 'definir_valor' ? '#e0e0e0' : 'transparent',
                      cursor: formData.tipoValor !== 'definir_valor' ? 'not-allowed' : 'text'
                    }}
                  />
                </td>
              </tr>
              <tr>
                <td className="label-precio">Precio media hora</td>
                <td className="valor-con-signo">
                  <span className="signo-peso">$</span>
                  <input
                    type="text"
                    name="precioMediaHora"
                    className="input-precio"
                    value={formData.precioMediaHora}
                    onChange={handlePrecioChange}
                    placeholder={formData.tipoValor === 'a_consultar' ? 'A consultar' : 'Coloca tu precio'}
                    disabled={formData.tipoValor !== 'definir_valor'}
                    style={{
                      backgroundColor: formData.tipoValor !== 'definir_valor' ? '#e0e0e0' : 'transparent',
                      cursor: formData.tipoValor !== 'definir_valor' ? 'not-allowed' : 'text'
                    }}
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        {/* Sección FOTOS */}
        <div className="seccion-form">
          <h3 className="titulo-seccion">☞ FOTOS</h3>
          <p className="descripcion-seccion">
            Agrega hasta un máximo de 10 fotos, mínimo son 5.<br />
            Ver las reglas para agregar las fotos.<br />
            <br />
            La <strong>FOTO 1</strong>, automáticamente va a ser la foto de portada de perfil de tu anuncio.
          </p>

<div className="multimedia-grid fotos-grid">
            {fotos.map((foto, index) => (
              <div key={`foto-${index}`} className="multimedia-item">
                <div 
                  className={`multimedia-preview ${index === 0 ? 'foto-perfil' : ''}`}
                  onClick={() => handleFotoClick(index)}
                >
                  {uploadingIndex === `foto-${index}` ? (
                    // Mostrar barra de progreso mientras carga
                    <div className="upload-progress-container">
                      <div className="upload-progress-bar">
                        <div 
                          className="upload-progress-fill"
                          style={{ width: `${uploadProgress[`foto-${index}`] || 0}%` }}
                        ></div>
                      </div>
                      <div className="upload-progress-text">
                        {uploadProgress[`foto-${index}`] || 0}%
                      </div>
                      <div className="upload-progress-label">
                        {(uploadProgress[`foto-${index}`] || 0) < 100
                          ? 'Subiendo...'
                          : 'Validando archivo, no cierres ni minimices esta ventana...'}
                      </div>
                      {(uploadProgress[`foto-${index}`] || 0) === 100 && (
                        <div style={{ textAlign: 'center', color: '#cccccc', fontSize: '11px', marginTop: '4px' }}>
                          {segundosVerificandoCuadro}s...
                        </div>
                      )}
                    </div>
) : obtenerPosicionEnCola('foto', index) ? (
                    <div className="upload-progress-container">
                      <div className="upload-progress-label" style={{ textAlign: 'center' }}>
                        En cola (#{obtenerPosicionEnCola('foto', index)})<br/>
                        Se subirá al terminar el actual.<br/>
                        No cierres ni minimices esta ventana.
                      </div>
                    </div>
) : foto ? (
                    <div style={{ position: 'relative', width: '100%', height: '100%' }}>
                      <img 
                        src={getObjectUrl(foto)} 
                        alt={`Foto ${index + 1}`}
                        className="preview-imagen"
                      />
                      <img
                        src={`${process.env.REACT_APP_UPLOADS_URL}/watermark_foto.png`}
                        alt="watermark"
                        style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: '55%', opacity: 0.6, pointerEvents: 'none' }}
                      />
                    </div>
                  ) : (
                    <img 
                      src={process.env.REACT_APP_LOGO_URL} 
                      alt="Logo Ulalaaa"
                      className="preview-logo"
                    />
                  )}
                </div>
                <input
                  id={`foto-camara-input-${index}`}
                  type="file"
                  accept="image/*"
                  capture="environment"
                  onChange={(e) => handleFotoIndividual(index, e)}
                  style={{ display: 'none' }}
                />
                <input
                  id={`foto-galeria-input-${index}`}
                  type="file"
                  accept="image/*"
                  onChange={(e) => handleFotoIndividual(index, e)}
                  style={{ display: 'none' }}
                />
                {!foto ? (
                  <div className="botones-subir-cuadro">
                    <button 
                      type="button" 
                      className="btn-subir-camara"
                      onClick={() => abrirSelectorArchivo(`foto-camara-input-${index}`)}
                    >
                      Tomar Foto
                    </button>
                    <button 
                      type="button" 
                      className="btn-subir-galeria"
                      onClick={() => abrirSelectorArchivo(`foto-galeria-input-${index}`)}
                    >
                      Galería
                    </button>
                  </div>
                ) : (
                  <button 
                    type="button" 
                    className="btn-eliminar"
                    onClick={() => handleEliminarFoto(index)}
                  >
                    {index === 0 ? 'Eliminar Foto Perfil' : 'Eliminar'}
                  </button>
                )}
              </div>
            ))}
          </div>

        </div>

        {/* Sección VIDEOS */}
        <div className="seccion-form">
          <h3 className="titulo-seccion">☞ VIDEOS</h3>
          <p className="descripcion-seccion">
            Agrega hasta un máximo de 15 videos, con un mínimo de 3.<br />
            Duración del video máximo es de 1 minuto.<br />
            Ver las reglas para agregar videos.<br />
            <br />
            <strong>El video 1</strong>, es el video promocional en tu perfil.
          </p>

<div className="multimedia-grid videos-grid">
            {videos.map((video, index) => (
              <div key={`video-${index}`} className="multimedia-item">
                <div 
                  className={`multimedia-preview ${index === 0 ? 'video-perfil' : ''}`}
                  onClick={() => handleVideoClick(index)}
                  style={{ cursor: 'pointer' }}
                >
                  {uploadingIndex === `video-${index}` ? (
                    // Mostrar barra de progreso mientras carga
                    <div className="upload-progress-container">
                      <div className="upload-progress-bar">
                        <div 
                          className="upload-progress-fill"
                          style={{ width: `${uploadProgress[`video-${index}`] || 0}%` }}
                        ></div>
                      </div>
                      <div className="upload-progress-text">
                        {uploadProgress[`video-${index}`] || 0}%
                      </div>
                      <div className="upload-progress-label">
                        {(uploadProgress[`video-${index}`] || 0) < 100
                          ? 'Subiendo...'
                          : 'Validando archivo, no cierres ni minimices esta ventana...'}
                      </div>
                      {(uploadProgress[`video-${index}`] || 0) === 100 && (
                        <>
                          <div className="spinner-verificando"></div>
                          <div style={{ textAlign: 'center', color: '#cccccc', fontSize: '11px', marginTop: '4px' }}>
                            {segundosVerificandoCuadro}s...
                          </div>
                        </>
                      )}
                    </div>
) : obtenerPosicionEnCola('video', index) ? (
                    <div className="upload-progress-container">
                      <div className="upload-progress-label" style={{ textAlign: 'center' }}>
                        En cola (#{obtenerPosicionEnCola('video', index)})<br/>
                        Se subirá al terminar el actual.<br/>
                        No cierres ni minimices esta ventana.
                      </div>
                    </div>
) : video ? (
                    <div className="video-thumbnail-container">
                      <video 
                        src={getObjectUrl(video)} 
                        className="preview-video-thumbnail"
                        playsInline
                        muted
                        preload="metadata"
                      />
                      <div className="play-overlay">▶</div>
                      <img
                        src={`${process.env.REACT_APP_UPLOADS_URL}/watermark_video.png`}
                        alt="watermark"
                        style={{ position: 'absolute', bottom: '8px', right: '8px', width: '30%', opacity: 0.75, pointerEvents: 'none' }}
                      />
                    </div>
                  ) : (
                    <img 
                      src={process.env.REACT_APP_LOGO_URL} 
                      alt="Logo Ulalaaa"
                      className="preview-logo"
                    />
                  )}
                </div>
                <input
                  id={`video-camara-input-${index}`}
                  type="file"
                  accept="video/*"
                  capture="environment"
                  onChange={(e) => handleVideoIndividual(index, e)}
                  style={{ display: 'none' }}
                />
                <input
                  id={`video-galeria-input-${index}`}
                  type="file"
                  accept="video/*"
                  onChange={(e) => handleVideoIndividual(index, e)}
                  style={{ display: 'none' }}
                />
                {!video ? (
                  <div className="botones-subir-cuadro">
                    <button 
                      type="button" 
                      className="btn-subir-camara"
                      onClick={() => {
                        if (uploadingIndex !== null || colaSubida.length > 0) {
                          mostrarAlertaPersonalizada('Debes esperar a que termine de subirse el video anterior antes de grabar otro.');
                          return;
                        }
                        abrirSelectorArchivo(`video-camara-input-${index}`);
                      }}
                      style={(uploadingIndex !== null || colaSubida.length > 0) ? { opacity: 0.5, cursor: 'not-allowed' } : {}}
                    >
                      Grabar Video
                    </button>
                    <button 
                      type="button" 
                      className="btn-subir-galeria"
                      onClick={() => abrirSelectorArchivo(`video-galeria-input-${index}`)}
                    >
                      Galería
                    </button>
                  </div>
                ) : (
                  <button 
                    type="button" 
                    className="btn-eliminar"
                    onClick={() => handleEliminarVideo(index)}
                  >
                    Eliminar
                  </button>
                )}
              </div>
            ))}
          </div>

        </div>

        {/* Sección ACEPTA LOS TÉRMINOS */}
        <div className="seccion-form">
          <h3 className="titulo-seccion">☞ ACEPTA LOS TÉRMINOS</h3>

          <div className="terminos-container">
            <label className="termino-item">
              <input
                type="checkbox"
                checked={terminos.termino1}
                onChange={() => handleTerminoChange('termino1')}
              />
              <span className="termino-texto">
                Para poder publicar un aviso en nuestro sitio, <span className="texto-destacado">debes aceptar que el incumplimiento de ciertas Normas de Publicación</span> como entregar información o imágenes que no sean reales, utilizar fotografías de otras personas sin su debido permiso, o emplear el anuncio con fines ilícitos, esto dará lugar a la <span className="texto-destacado">eliminación del mismo y a la imposibilidad de continuar con el proceso de pago</span>.
                <br /><br />
                <span className="texto-destacado">Dispones de dos intentos para publicar tu anuncio</span> utilizando la misma cuenta de correo electrónico registrada. En caso de que sea <span className="texto-destacado">rechazado por tercera vez</span>, se procederá al <span className="texto-destacado">bloqueo de tu correo</span> y a la desactivación de tu acceso al sitio, debido al uso incorrecto de la plataforma y al incumplimiento de las políticas establecidas por nuestro sitio ULALAAA.
              </span>
            </label>

            <label className="termino-item">
              <input
                type="checkbox"
                checked={terminos.termino2}
                onChange={() => handleTerminoChange('termino2')}
              />
              <span className="termino-texto">
                Yo <span className="texto-destacado">declaro que tengo mas de 18 años</span>, acepto el <span className="texto-destacado">proceso de verificación</span> y lo que ello implica, también estoy dispuesta/o para publicar y aceptar <span className="texto-destacado">videos promocionales</span>, los cuales serán visibles al inicio de nuestro sitio. (Detalles visita sitio : <a href="/textos-legales" target="_blank" rel="noopener noreferrer" className="texto-destacado-subrayado">TERMINOS Y CONDICIONES</a>.
              </span>
            </label>

            <label className="termino-item">
              <input
                type="checkbox"
                checked={terminos.termino3}
                onChange={() => handleTerminoChange('termino3')}
              />
              <span className="termino-texto">
                Yo declaro a ver leído las reglas y <a href="/textos-legales" target="_blank" rel="noopener noreferrer" className="texto-destacado-subrayado">ACEPTO TERMINOS Y CONDICIONES</a>
              </span>
            </label>
          </div>
        </div>

{/* Botón de envío */}
        <div className="boton-envio-container">
          <button 
            type="submit" 
            className="btn-enviar-publicacion"
            disabled={enviando}
            style={(enviando || uploadingIndex !== null || colaSubida.length > 0) ? { opacity: 0.5, cursor: 'not-allowed' } : {}}
          >
            ENVIAR TU PUBLICACIÓN
          </button>

          {/* Barra de progreso de carga */}
          {showBarraCarga && (
            <div style={{
              marginTop: '20px',
              width: '100%',
              maxWidth: '500px',
              margin: '20px auto 0 auto',
              opacity: barraSaliendo ? 0 : 1,
              transition: 'opacity 0.4s ease'
            }}>
              <div style={{
                fontFamily: "'Arial Black', Arial, sans-serif",
                fontSize: '14px',
                color: '#ffffff',
                fontWeight: 'bold',
                textAlign: 'center',
                marginBottom: '8px'
              }}>
                {progresoCarga < 90
                  ? `Procesando tu publicación... ${progresoCarga}%`
                  : progresoCarga < 100
                  ? 'Verificando archivos... espera hasta que se suba todo, no salgas ni minimices esta pantalla.'
                  : '¡Publicación completada! 100%'}
              </div>
              <div style={{
                width: '100%',
                height: '24px',
                backgroundColor: '#333333',
                borderRadius: '12px',
                overflow: 'hidden',
                border: '2px solid #FFD700'
              }}>
                <div style={{
                  width: `${progresoCarga}%`,
                  height: '100%',
                  backgroundColor: progresoCarga === 100 ? '#00aa00' : '#FFD700',
                  borderRadius: '12px',
                  transition: 'width 0.3s ease, background-color 0.5s ease'
                }} />
              </div>
              {progresoCarga === 90 && (
                <>
                  <div className="spinner-verificando" style={{ margin: '10px auto 0 auto' }}></div>
                  <div style={{
                    textAlign: 'center',
                    color: '#cccccc',
                    fontSize: '12px',
                    marginTop: '6px'
                  }}>
                    Verificando hace {segundosVerificando}s...
                  </div>
                </>
              )}
            </div>
          )}
          {mensajeError && (
            <div style={{
              color: '#ff0000',
              fontSize: '14px',
              fontFamily: "'Arial Black', Arial, sans-serif",
              fontWeight: 'bold',
              textAlign: 'center',
              marginTop: '15px'
            }}>
              {mensajeError}
            </div>
          )}
        </div>

        {/* Modal Ticket Generado */}
        {showTicketModal && (
          <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            backgroundColor: 'rgba(0,0,0,0.85)',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 9999
          }}>
            <div style={{
              textAlign: 'center',
              padding: '40px'
            }}>
              <p style={{
                fontFamily: "'Arial Black', Arial, sans-serif",
                fontSize: '30px',
                fontWeight: '900',
                color: '#ffffff',
                marginBottom: '20px'
              }}>
                ¡PUBLICACIÓN ENVIADA!
              </p>
              <p style={{
                fontFamily: "'Arial Black', Arial, sans-serif",
                fontSize: '30px',
                fontWeight: '900',
                color: '#FFD700',
                marginBottom: '20px'
              }}>
                TU N° DE TICKET ES:
              </p>
              <p style={{
                fontFamily: "'Arial Black', Arial, sans-serif",
                fontSize: '60px',
                fontWeight: '900',
                color: '#FFD700',
                marginBottom: '30px',
                letterSpacing: '8px'
              }}>
                {ticketGenerado}
              </p>
              <p style={{
                fontFamily: 'Arial, sans-serif',
                fontSize: '18px',
                color: '#cccccc'
              }}>
                Serás redirigido a Estado de Publicaciones en 5 segundos...
              </p>
            </div>
          </div>
        )}

        {/* Modal de Alerta Personalizada (reemplaza alert() nativo) */}
        {mostrarModalAlerta && (
          <div style={{
            position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh',
            backgroundColor: 'rgba(0,0,0,0.85)', display: 'flex',
            justifyContent: 'center', alignItems: 'center', zIndex: 9999
          }}>
            <div style={{
              background: '#1a1a1a', padding: '30px', borderRadius: '10px',
              maxWidth: '90%', textAlign: 'center'
            }}>
              <p style={{ color: '#ffffff', fontSize: '16px', marginBottom: '20px', whiteSpace: 'pre-line' }}>
                {mensajeModalAlerta}
              </p>
              <button
                type="button"
                onClick={() => setMostrarModalAlerta(false)}
                style={{
                  padding: '10px 30px', background: '#FFD700', border: 'none',
                  borderRadius: '5px', fontWeight: 'bold', cursor: 'pointer'
                }}
              >
                Aceptar
              </button>
            </div>
          </div>
        )}

                {/* Modal de Video */}
        {showVideoModal && (
          <div className="video-modal-overlay" onClick={closeVideoModal}>
            <div className="video-modal-content" onClick={(e) => e.stopPropagation()}>
              <button className="video-modal-close" onClick={closeVideoModal}>✕</button>
              
<div style={{ position: 'relative', width: '100%' }}>
                <video 
                  ref={videoPlayerRef}
                  src={currentVideoSrc}
                  className="video-modal-player"
                  onTimeUpdate={handleVideoTimeUpdate}
                  onLoadedMetadata={handleVideoLoadedMetadata}
                  onEnded={() => setIsVideoPlaying(false)}
                />
                <img
                  src={`${process.env.REACT_APP_UPLOADS_URL}/watermark_video.png`}
                  alt="watermark"
                  style={{ position: 'absolute', bottom: '8px', right: '8px', width: '30%', opacity: 0.75, pointerEvents: 'none' }}
                />
              </div>
              
              {/* Barra de progreso del video */}
              <div className="video-progress-container">
                <input
                  type="range"
                  min="0"
                  max={videoDuration || 0}
                  value={videoCurrentTime}
                  onChange={handleTimeChange}
                  className="video-progress-slider"
                />
                <div className="video-time-display">
                  {formatearTiempo(videoCurrentTime)} / {formatearTiempo(videoDuration)}
                </div>
              </div>
              
              {/* Controles del video */}
              <div className="video-modal-controls">
                <button 
                  className="btn-video-control btn-play"
                  onClick={playVideo}
                  disabled={isVideoPlaying}
                >
                  ▶ Play
                </button>
                <button 
                  className="btn-video-control btn-pause"
                  onClick={pauseVideo}
                  disabled={!isVideoPlaying}
                >
                  ⏸ Pause
                </button>
                <button 
                  className="btn-video-control btn-stop"
                  onClick={stopVideo}
                >
                  ⏹ Stop
                </button>
                
                {/* Control de volumen */}
                <div className="volume-control">
                  <span className="volume-icon">🔊</span>
                  <input
                    type="range"
                    min="0"
                    max="1"
                    step="0.1"
                    value={videoVolume}
                    onChange={handleVolumeChange}
                    className="volume-slider"
                  />
                  <span className="volume-percentage">{Math.round(videoVolume * 100)}%</span>
                </div>
              </div>
            </div>
          </div>
        )}
        
        {/* Modal de Foto */}
{showFotoModal && (
          <div className="video-modal-overlay" onClick={closeFotoModal}>
            <div className="video-modal-content" onClick={(e) => e.stopPropagation()}>
              <button className="video-modal-close" onClick={closeFotoModal}>✕</button>
<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%' }}>
                <div style={{ position: 'relative', display: 'inline-block' }}>
                  <img 
                    src={currentFotoSrc} 
                    alt="Foto ampliada"
                    style={{ maxWidth: '100%', borderRadius: '5px', maxHeight: '80vh', objectFit: 'contain', display: 'block' }}
                  />
                  <img
                    src={`${process.env.REACT_APP_UPLOADS_URL}/watermark_foto.png`}
                    alt="watermark"
                    style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: '55%', opacity: 0.6, pointerEvents: 'none' }}
                  />
                </div>
              </div>
            </div>
          </div>
        )}



</form>

      {/* Footer */}
      <footer className="home-footer">
        <div className="home-footer-top">
          <div className="home-footer-redes">
            <a href="https://www.instagram.com/ulalaaaoficial" target="_blank" rel="noopener noreferrer" className="home-footer-social-link">
              <i className="fab fa-instagram"></i>
            </a>
            <a href="https://www.tiktok.com/@ulalaaaoficial2" target="_blank" rel="noopener noreferrer" className="home-footer-social-link">
              <i className="fab fa-tiktok"></i>
            </a>
            <a href="#" className="home-footer-social-link">
              <i className="fab fa-youtube"></i>
            </a>
            <a href="https://wa.me/56929674732" target="_blank" rel="noopener noreferrer" className="home-footer-social-link">
              <i className="fab fa-whatsapp"></i>
            </a>
            <a href="#" className="home-footer-social-link">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" style={{width:'22px',height:'22px'}}>
                <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.746l7.73-8.835L1.254 2.25H8.08l4.259 5.63 5.905-5.63zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
              </svg>
            </a>
            <a href="https://t.me/+56929674732" target="_blank" rel="noopener noreferrer" className="home-footer-social-link">
              <i className="fab fa-telegram"></i>
            </a>
          </div>
          <div className="home-footer-logo">
            <img
              src={`${process.env.REACT_APP_UPLOADS_URL}/logotipo_new8.jpg`}
              alt="Ulalaaa Logo"
              className="home-footer-logo-img"
            />
          </div>
          <div className="home-footer-legal-links">
            <a href="/textos-legales#terminos" className="home-footer-legal-btn">Información Legal - Términos y Condiciones</a>
            <a href="/textos-legales#privacidad" className="home-footer-legal-btn">Política de Privacidad</a>
          </div>
        </div>
        <div className="home-footer-texto">
          Ulalaaa, es un sitio web exclusivo para mayores de 18 años, tanto para las personas publicadas como las que lo visitan, las personas publicadas son verificadas de forma rigurosa, el cual han dado su consentimiento para ser publicadas, este sitio no es una agencia, es solo un medio publicitario que no interviene con ninguna relación laboral con las personas publicadas.
        </div>
        <div className="home-footer-copyright">
          ©2026 Ulalaaa - Todos los derechos Reservados.
        </div>
      </footer>
    </div>
  );
};

export default PublicaAnuncio;
